import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { Tooltip } from "../TODO-put-in-package/Tooltip"
import { useCursorTracking } from "tools/events/useCursorProvider"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectActiveToolName, setActiveTool } from "plugins/Toolbox/tool-registry"
import { clearSelection } from "panels/content/side-panel/slice.new"
import { ToolboxPlugin } from "plugins/plugin-registry"
import { ToolName } from "@nova/constants"
import { selectIsMapCommentThreadOpen } from "features/entity-caching/map-comments/selectors"

export const TopBarTool = ({ icon, name, shortcut }: Omit<ToolboxPlugin, "type">) => {
    const dispatch = useAppDispatch()
    const activeTool = useAppSelector(selectActiveToolName())
    const isCommentThreadOpen = useAppSelector(selectIsMapCommentThreadOpen)
    const isActive = activeTool === name || (name === ToolName.Comment && isCommentThreadOpen)
    const id = `${name}-pubsub`
    useCursorTracking(id)

    return (
        <div
            id={id}
            className={classNames(
                "w-9 h-9 rounded-md flex items-center justify-center relative group/tooltip disabled:text-gray-500 outline-none focus:ring-0 cursor-pointer",
                {
                    "bg-blue-500 text-gray-800": isActive,
                    "hover:bg-gray-700 text-gray-100 hover:text-gray-0": !isActive,
                }
            )}
            onClick={() => {
                dispatch(clearSelection())
                dispatch(setActiveTool(activeTool !== name ? name : undefined))
            }}
        >
            <Icons.Icon Icon={icon} />
            <Tooltip title={name} shortcut={shortcut} />
        </div>
    )
}
